import { render } from "./tnc-modal.vue?vue&type=template&id=1d29b2b8"
import script from "./tnc-modal.vue?vue&type=script&lang=js"
export * from "./tnc-modal.vue?vue&type=script&lang=js"

import "./tnc-modal.vue?vue&type=style&index=0&id=1d29b2b8&lang=css"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__